/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState} from 'react';
import PageBox from "../../layouts/pageBox";
import ImgGoogle from "../../assets/img/forms/google.png";
import ImageMask from "../../assets/img/login/register-mask.png";
import {ReactComponent as Email} from "../../assets/img/forms/email.svg";
import {ReactComponent as Eye} from "../../assets/img/forms/eye.svg";
import {ReactComponent as CheckboxEmpty} from "../../assets/img/forms/checkbox-empty.svg";
import {ReactComponent as CheckboxFull} from "../../assets/img/forms/checkbox-full.svg";
import {ReactComponent as ArrowRight} from "../../assets/img/icons/arrow-right-white.svg";
import {ReactComponent as Icon1} from "../../assets/img/login/icon1.svg";
import {ReactComponent as Icon2} from "../../assets/img/login/icon2.svg";
import {ReactComponent as Icon3} from "../../assets/img/login/icon3.svg";
import {ReactComponent as Icon4} from "../../assets/img/login/icon4.svg";
import {ReactComponent as Icon5} from "../../assets/img/login/icon5.svg";
import {ReactComponent as Icon6} from "../../assets/img/login/icon6.svg";
import {ReactComponent as Icon7} from "../../assets/img/login/icon7.svg";
import {ReactComponent as Icon8} from "../../assets/img/login/icon8.svg";
import {Link, useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";
import Loader from "../../elements/loader";
import ModelPartsForm from "../../components/ModelPartsForm";

const Register = () => {

    const [showPass, setShowPass] = useState(false);
    const [success, setSuccess] = useState(false);
    const axiosJWT = useAxiosJTW();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    function toogleShow(){
        setShowPass(v => !v);
    }

    const data = {
        title: '',
        subtitle: ''
    };

    const { control, register, handleSubmit, watch, reset, setError, formState: { errors }, trigger, clearErrors } = useForm({
        mode: "onChange"
    });

    const checkemail = (data) =>{
        axiosJWT.post('api/checkemail', data).then( (response)=>{

            //ok            success, paymentmethods.
            //merchant      error 4  Email already exists
            //user          error 3   user_id,  paymentmethods Email already exists

            if(response.data.error == 3){
                setError("email", { type: "unique", message:`${t('login.Emailalreadyexists')}` }, { shouldFocus: true });
                return;
            }
            if(response.data.error == 4){
                setError("email", { type: "unique", message:`${t('login.Emailmerchantaccount')}` }, { shouldFocus: true });
                return;
            }

            userRegister(data);


        }).catch((error) => {
            console.log(error);
        });
    }

    const userRegister = (data) => {
        axiosJWT.post('api/register', data).then( (response) => {

            if(response.data.user_register){
                setSuccess(true);
            }

        } ).catch((error) => {
            console.log(error);
        });
    }

    const onSubmit = data => {
        checkemail(data);
    };

    useEffect( () =>{
        //navigate(`/${i18n.language}/`);
    }, [] )

    return (
        <PageBox data={data} small={true}>
            <div className='page-body'>
                <div className='login-row row'>
                    <img className='register-bg-img' src={ImageMask} alt='bg image' />
                    <div className='col-md-6 order-md-2'>
                        <div className='login'>
                            <div className='login__title'>{t('login.myAccount')}</div>

                            {success ? (
                                <div className="alert alert-success" role="alert">
                                    <p className="font-weight-bold mb-1">{t('login.succesfullyregistered')}</p>
                                    <p>{t('login.emailinstructions')}</p>
                                    <p>{t('login.Please')} <Link to={`/${i18n.language}/login`} className='alert-link'>{t('login.login')}</Link></p>
                                </div>
                            ) : (
                                <form className='login-form' onSubmit={handleSubmit(onSubmit)}>

                                    <div className="form-group">
                                        <label htmlFor='fname'>{t('fields.fname')}</label>
                                        <div className='form-group__wrap'>
                                            <input id='fname' className="form-control" type="text" {...register("fname",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.fnamePlace')}/>
                                        </div>
                                        { errors.fname && <small className="text-danger">{errors.fname?.message}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor='lname'>{t('fields.lname')}</label>
                                        <div className='form-group__wrap'>
                                            <input id='lname' className="form-control" type="text" {...register("lname",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.lnamePlace')}/>
                                        </div>
                                        { errors.lname && <small className="text-danger">{errors.lname?.message}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor='phone'>{t('fields.phone')}</label>
                                        <div className='form-group__wrap'>
                                            <input id='phone' className="form-control" type="text" {...register("phone",{
                                                // required: 'Required Field',
                                                minLength: {
                                                    value: 10,
                                                    message: 'At least 10 digits'
                                                },
                                            } )} placeholder={t('fields.phonePlace')}/>
                                        </div>
                                        { errors.phone && <small className="text-danger">{errors.phone?.message}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor='loginEmail'>{t('fields.email')}</label>
                                        <div className='form-group__wrap'>
                                            <input id='loginEmail' className="form-control" type="email" {...register("email",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.emailPlace')}/>
                                            <span className='form-group__icon'><Email/></span>
                                        </div>
                                        { errors.email && <small className="text-danger">{errors.email?.message}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor='loginPassword'>{t('fields.password')}</label>
                                        <div className='form-group__wrap'>
                                            <input id='loginPassword' className="form-control" type={showPass ? "text" : "password"} {...register("password",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.passPlace')}/>
                                            <span className='form-group__icon form-group__icon--password' onClick={toogleShow}>
                                        {!showPass
                                            ? <span className='icon--opened'><Eye/></span>
                                            : <span className='icon--closed'><Eye/></span>
                                        }
                                        </span>
                                        </div>
                                        { errors.password && <small className="text-danger">{errors.password?.message}</small>}
                                    </div>

                                    <div className="form-group mb-4">
                                        <label className="custom-checkbox">
                                            <input type="checkbox" value="1" {...register("newsletter" )}/>
                                            <span className="custom-checkbox__icon custom-checkbox__empty"><CheckboxEmpty/></span>
                                            <span className="custom-checkbox__icon custom-checkbox__checked"><CheckboxFull/></span>
                                            {t('fields.newsletter')}
                                        </label>
                                        { errors.newsletter && <small className="form-error text-danger">{errors.newsletter?.message}</small>}
                                    </div>
                                    <div className="form-group mb-4">
                                        <label className="custom-checkbox">
                                            <input
                                                type="checkbox"
                                                value="1"
                                                {...register("terms", {required: `${t('fields.requiredfield')}`} )}
                                            />
                                            <span className="custom-checkbox__icon custom-checkbox__empty"><CheckboxEmpty/></span>
                                            <span className="custom-checkbox__icon custom-checkbox__checked"><CheckboxFull/></span>
                                            {t('fields.terms')}
                                        </label>
                                        { errors.terms && <small className="form-error text-danger">{errors.terms?.message}</small>}
                                    </div>

                                    <button type="submit" className='btn btn-primary btn-icon btn-icon-right btn-block'>{t('register.registerButton')}<ArrowRight/></button>

                                    <div className='mixed-link pt-5'>
                                            {/*<div className='mixed-link__text'>{t('register.registerAlready')} </div>*/}
                                            <Link to={`/${i18n.language}/login`} className='mixed-link__link'>{t('register.registerAlready')}</Link>
                                    </div>

                                </form>
                            )}


                        </div>
                    </div>

                    <div className='col-md-6 order-md-1'>
                        <div className='loginDetails'>
                            <div className='loginDetails__title'>{t('register.registerTitle')}</div>
                            <div className='loginDetails__text'>{t('register.registerText')}</div>
                            <ul className='loginDetails__list'>
                                <li>{t('register.registerText1')}</li>
                                <li>{t('register.registerText2')}</li>
                                <li>{t('register.registerText3')}</li>
                            </ul>

                        </div>
                    </div>

                </div>
            </div>
        </PageBox>
    );
};

export default Register;
